import { useIntercomContext } from './provider';

export const useIntercom = () => {
  return useIntercomContext();
};
